import {
  type SearchLanesRequest,
  type GetLaneRequest,
  type SearchUserLanesRequest,
} from '@trukt/tms-api/LaneService';
import { createKey } from '../createKey';

const keyHandler = createKey('lane');
const userLaneKeyHandler = createKey('userLane');

export const LaneServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<SearchLanesRequest>(),
  getById: keyHandler.createMethod<GetLaneRequest>(),
  userLanes: {
    key: userLaneKeyHandler.key,
    search: userLaneKeyHandler.createMethod<SearchUserLanesRequest>(),
  },
};
